import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = { class: "dialog" };
import { ref } from 'vue';
import { useToast } from 'vue-toastification';
import { mixpanelSmsCampaign } from '@/utilities/mixpanel/smsCampaigns';
import { activateOrDeactivateSmsCampaign } from '@/features/SMSCampaigns/data';
import i18n from '@/i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SMSCampaignsModalInactivate',
    props: {
        isVisible: { type: Boolean },
        campaign: {}
    },
    emits: ['closeModal', 'reloadTable'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const { t } = i18n.global;
        const toast = useToast();
        const isLoading = ref(false);
        const confirm = () => {
            mixpanelSmsCampaign.inactivateConfirm(props.campaign);
            isLoading.value = true;
            const DEACTIVATE = 1;
            activateOrDeactivateSmsCampaign(props.campaign.campaignId, DEACTIVATE)
                .then(isSuccessful => {
                if (isSuccessful) {
                    toast.success(t('sms-campaigns.table.toast-update-status-success'), { timeout: 3000 });
                    return;
                }
                toast.error(t('sms-campaigns.table.toast-update-status-error'), { timeout: 3000 });
            })
                .catch(() => {
                toast.error(t('sms-campaigns.table.toast-update-status-error'), { timeout: 3000 });
            })
                .finally(() => {
                closeModal();
                emits('reloadTable');
                isLoading.value = false;
            });
        };
        const cancel = () => {
            mixpanelSmsCampaign.inactivateCancel(props.campaign);
            emits('closeModal');
        };
        const closeModal = () => {
            emits('closeModal');
        };
        return (_ctx, _cache) => {
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_dialog = _resolveComponent("el-dialog");
            return (_openBlock(), _createBlock(_component_el_dialog, {
                onClose: closeModal,
                "model-value": props.isVisible,
                title: _ctx.$tc('sms-campaigns.table.modal-inactivate-title'),
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": false,
                class: "sms-campaigns-modal-inactivate",
                width: "360",
                "append-to-body": ""
            }, {
                default: _withCtx(() => [
                    _createElementVNode("p", {
                        innerHTML: _ctx.$tc('sms-campaigns.table.modal-inactivate-text', { campaign: props.campaign.name })
                    }, null, 8, _hoisted_1),
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_el_button, {
                            round: "",
                            class: "btn btn-outline-ctx-primary",
                            onClick: cancel
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('_cancel', 2)), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_el_button, {
                            class: "btn btn-primary",
                            round: "",
                            onClick: confirm,
                            loading: isLoading.value
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$tc('_inactivate', 2)), 1)
                            ]),
                            _: 1
                        }, 8, ["loading"])
                    ])
                ]),
                _: 1
            }, 8, ["model-value", "title"]));
        };
    }
});
